"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
exports.AcInfoCardWidth = 165;
exports.AcInfoCardHeight = 80; // Including border
exports.AcInfoCard = function (_a) {
    var block = _a.block, _b = _a.width, width = _b === void 0 ? block ? undefined : exports.AcInfoCardWidth : _b, height = _a.height, _c = _a.active, active = _c === void 0 ? false : _c, variant = _a.variant, name = _a.name, onClick = _a.onClick, _d = _a.className, className = _d === void 0 ? '' : _d, title = _a.title, description = _a.description, children = _a.children;
    var onClickCard = function () {
        if (onClick)
            onClick(name);
    };
    var activeStyle = function () {
        return !active ? 'border-apzlightblue' : 'border-primary';
    };
    return (react_1.default.createElement(react_bootstrap_1.Card, { onClick: onClickCard, className: className + " " + (variant === 'info' ? 'bg-apzlightblue' : '') + " border-2 " + activeStyle() + " " + (block ? 'w-100' : ''), style: {
            width: width,
            minWidth: width,
            maxWidth: width,
            height: height,
            minHeight: height,
            maxHeight: height,
            overflow: 'hidden',
            cursor: onClick ? 'pointer' : 'auto',
        } },
        react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "text-center text-primary h-100 px-4 d-flex flex-column justify-content-center" },
            title && react_1.default.createElement(react_bootstrap_1.Card.Title, { className: "fs-10 font-weight-bold mb-1" }, title),
            react_1.default.createElement("div", { className: "d-flex justify-content-center align-items-center", style: width ? { width: width - 45 + "px" } : {} }, children),
            description && react_1.default.createElement("div", { className: "fs-7" }, description))));
};
exports.AcInfoCard.displayName = 'AcInfoCard';
//# sourceMappingURL=AcInfoCard.js.map